import { gql } from '@apollo/client'

export const TYPE_EQUIPEMENT_EQUIPEMENT = gql`
  query TypeEquipementEquipement($coproprieteid: bigint!) {
    typeEquipement: d4_typeequipement(order_by: { typeequipement: asc }) {
      id
      typeequipement
      fields
      equipements(
        where: {
          _or: [
            { copropriete: { id: { _eq: $coproprieteid } } }
            { batiment: { copropriete: { id: { _eq: $coproprieteid } } } }
          ]
        }
      ) {
        id
        libelle
        batiment_id
        copropriete_id
        data
        fournisseur_favori_equipements {
          id
          societe {
            id
            raisonsociale
          }
        }
      }
    }
  }
`

export const TYPE_EQUIPEMENT_QUERY = gql`
  query TypeEquipement($id: bigint!, $coproprieteid: bigint!) {
    typeEquipement: d4_typeequipement_by_pk(id: $id) {
      id
      typeequipement
      fields
      equipements(
        where: {
          _or: [
            { copropriete: { id: { _eq: $coproprieteid } } }
            { batiment: { copropriete: { id: { _eq: $coproprieteid } } } }
          ]
        }
      ) {
        id
        libelle
        batiment_id
        copropriete_id
        data
      }
    }
  }
`

export const TYPE_EQUIPEMENT_ADD_FIELD_MUTATION = gql`
  mutation TypeEquipementAddField($id: bigint!, $data: d4_typeequipement_set_input!) {
    typeEquipement: update_d4_typeequipement_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      fields
    }
  }
`
